export default (theme: any) => ({
    pdf: {
        marginTop: '20px',
    },

    button: {
        marginTop: '20px',
    },

    media: {
        height: '100vh',
        width: '70vw',
        marginTop: '20px',
        border: '2px solid grey',
    },

    buttonProgress: {
        color: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },

    buttonHolder: {
        borderRadius: '2px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '10px',
            minWidth: '45%',
        },
        position: 'relative',
    },
})
